let symbolChangedSub: { unsubscribe: () => void } | null = null;

export function subscribeToActiveChartSymbol(tvWidgetChart: any, datafeed: any) {
    // 1. Cleanup old subscription
    if (symbolChangedSub) {
        symbolChangedSub.unsubscribe();
        symbolChangedSub = null;
    }

    const chart = tvWidgetChart.activeChart();

    // 2. Subscribe to new active chart
    symbolChangedSub = chart.onSymbolChanged().subscribe(null, () => {
        datafeed.setHeaderSymbol(chart.symbol());
    });

    // 3. Sync immediately
    datafeed.setHeaderSymbol(chart.symbol());
};
